export default __webpack_public_path__ + "static/media/01.88f32690.png";